import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
  FiPhone,
  FiMail,
  FiMapPin,
  FiFacebook,
  FiInstagram,
  FiTwitter,
  FiClock,
  FiShield,
  FiTruck,
  FiCreditCard,
} from "react-icons/fi";
import { FaTiktok } from "react-icons/fa"; // Agregar esta línea
import { useNavigate, Link } from "react-router-dom";
import footerService, { FooterSettings } from '../../services/footerService';
import { settingsService, Settings } from '../../services/settingsService';

// Convertir los iconos a componentes React válidos
const Phone = () => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>
);
const Mail = FiMail as React.ComponentType;
const MapPin = FiMapPin as React.ComponentType;
const Facebook = FiFacebook as React.ComponentType;
const Instagram = FiInstagram as React.ComponentType;
const Twitter = FiTwitter as React.ComponentType;
const Clock = FiClock as React.ComponentType;
const Shield = FiShield as React.ComponentType;
const Truck = FiTruck as React.ComponentType;
const CreditCard = FiCreditCard as React.ComponentType;
const TikTok = FaTiktok as React.ComponentType; // Agregar esta línea

const FooterContainer = styled.footer`
  background: #1a1a1a;
  color: white;
`;

const NewsletterSection = styled.div`
  background: #2c3e50;
  padding: 2rem 0;
  text-align: center;
`;

const NewsletterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const NewsletterTitle = styled.h3`
  color: white;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
`;

const NewsletterSubtitle = styled.p`
  color: #bdc3c7;
  margin-bottom: 1.5rem;
`;

const NewsletterForm = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  max-width: 500px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const NewsletterInput = styled.input`
  flex: 1;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #3498db;
  }
`;

const NewsletterButton = styled.button`
  background: #e74c3c;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: #c0392b;
  }
`;

const MainFooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 2rem 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
`;

const SectionTitle = styled.h3`
  color: #fdbf37;
  font-size: 1.1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const ContactInfo = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  color: #bdc3c7;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;

  svg {
    margin-top: 0.2rem;
    flex-shrink: 0;
  }
`;

const QuickLink = styled.a`
  color: #bdc3c7;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
  cursor: pointer;
  margin-bottom: 0.5rem;

  &:hover {
    color: #3498db;
  }
`;

const PaymentMethodsSection = styled.div`
  background: #2c2c2c;
  padding: 2rem 0;
  border-top: 1px solid #333;
`;

const PaymentContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  align-items: center;
`;

const PaymentMethods = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
`;

const PaymentCard = styled.div`
  background: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-weight: 600;
  color: #333;
  font-size: 0.8rem;
`;

const SecurityBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
`;

const SecurityBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #bdc3c7;
  font-size: 0.8rem;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #fdbf37;
  color: #0a1165;
  border-radius: 50%;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: #0a1165;
    color: #fdbf37;
    transform: translateY(-2px);
  }
`;

const LibroReclamacionesIcon = styled.img`
  width: 80px;
  height: 60px;
  display: block;
  margin: 18px 0 0 14%;
  padding: 0;
  background: none;
  border-radius: 0;
  box-shadow: none;
  cursor: pointer;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.08);
  }
`;

const FooterBottom = styled.div`
  background: #111;
  padding: 1rem 0;
  text-align: center;
  color: #666;
  font-size: 0.8rem;
  border-top: 1px solid #333;
`;

const BottomContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const [footerData, setFooterData] = useState<FooterSettings>({
    contact_address: 'Av. Centenario #220',
    contact_phone: '',
    contact_email: 'servicios@datax.com',
    social_facebook: 'https://www.facebook.com/vargashomecenter',
    social_instagram: 'https://www.instagram.com/vargashomecenter/',
    social_tiktok: 'https://www.tiktok.com/@vargas.homecenter',
    social_youtube: '',
    copyright_text: '© 2025 DataX. Todos los derechos reservados.',
    developed_by: 'Desarrollado con ❤️ por DataX para nuestros clientes'
  });
  const [settings, setSettings] = useState<Settings | null>(null);

  useEffect(() => {
    const loadFooterData = async () => {
      try {
        const footerSettings = await footerService.getFooterSettings();
        setFooterData(footerSettings);
        
        const appSettings = await settingsService.getSettings();
        setSettings(appSettings);
      } catch (error) {
        console.error('Error al cargar configuraciones del footer:', error);
        // Mantener datos por defecto si hay error
      }
    };

    loadFooterData();
  }, []);

  return (
    <FooterContainer>
      {/* Main Footer Content */}
      <MainFooterContent>
        <FooterSection>
          <SectionTitle>Contactanos</SectionTitle>
          {footerData.contact_phone && (
            <ContactInfo>
              <Clock />
              <div>
                <div>Horario de Atención</div>
                <div>{footerData.contact_phone}</div>
              </div>
            </ContactInfo>
          )}
          {settings?.whatsapp_number && (
            <ContactInfo>
              <Phone />
              <div>
                <div>Atención al cliente</div>
                <div>{settings.whatsapp_number}</div>
              </div>
            </ContactInfo>
          )}
          <ContactInfo>
            <Mail />
            <div>
              <div>Escríbenos para ayudarte en</div>
              <div>{footerData.contact_email}</div>
            </div>
          </ContactInfo>
          <ContactInfo>
            <MapPin />
            <div>
              <div>Dirección</div>
              <div>{footerData.contact_address}</div>
            </div>
          </ContactInfo>
        </FooterSection>

        <FooterSection>
          <SectionTitle>Secciones</SectionTitle>
          <QuickLink as={Link} to="/nosotros">Nosotros</QuickLink>
          <QuickLink as={Link} to="/productos">Nuestros productos</QuickLink>
          <QuickLink as={Link} to="/">Tutoriales</QuickLink>
        </FooterSection>

        <FooterSection>
          <SectionTitle>Atención al cliente</SectionTitle>
          <QuickLink as={Link} to="/">Preguntas frecuentes</QuickLink>
          <QuickLink as={Link} to="/">Política de privacidad</QuickLink>
          <QuickLink href="/pdfs/politica-despacho-obra.pdf" target="_blank" rel="noopener noreferrer">Política de despacho a Obra</QuickLink>
          <QuickLink href="/pdfs/politica-despacho-domicilio.pdf" target="_blank" rel="noopener noreferrer">Política de despacho a Domicilio</QuickLink>
          <QuickLink href="/pdfs/terminos-condiciones-recojo-tienda.pdf" target="_blank" rel="noopener noreferrer">Terminos y condiciones de recojo en tienda</QuickLink>
          <QuickLink as={Link} to="/contacto">Contactanos</QuickLink>
        </FooterSection>

        <FooterSection>
          <SectionTitle>Síguenos en</SectionTitle>
          <SocialLinks>
            {footerData.social_facebook && (
              <SocialLink
                href={footerData.social_facebook}
                aria-label="Facebook"
              >
                <Facebook />
              </SocialLink>
            )}
            {footerData.social_instagram && (
              <SocialLink
                href={footerData.social_instagram}
                aria-label="Instagram"
              >
                <Instagram />
              </SocialLink>
            )}
            {footerData.social_tiktok && (
              <SocialLink
                href={footerData.social_tiktok}
                aria-label="TikTok"
              >
                <TikTok />
              </SocialLink>
            )}
          </SocialLinks>
          <LibroReclamacionesIcon
            src="/icon-libro-reclamaciones.png"
            alt="Libro de Reclamaciones"
            title="Libro de Reclamaciones"
            onClick={() => navigate("/libro-reclamaciones")}
          />
        </FooterSection>
      </MainFooterContent>
      {/* Footer Bottom */}
      <FooterBottom>
        <BottomContent>
          <div>{footerData.copyright_text}</div>
          <div>{footerData.developed_by}</div>
        </BottomContent>
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
